export const unreachable = (_: never) => {
  throw new Error("Unreachable code");
};
